const shareTeams = document.getElementById('shareTeams');
let scriptLoaded = false;

export function loadAndExecute() {
  if (!scriptLoaded) {
    const script = document.createElement('script');
    script.src = 'https://teams.microsoft.com/share/launcher.js';
    script.async = true;
    script.defer = true;
    script.onload = async function () {
      scriptLoaded = true;
      await onLoadComplete();
      shareTeams.click();
    };
    document.head.appendChild(script);
  }
}

async function onLoadComplete() {
  await window.shareToMicrosoftTeams?.renderButtons({elements: [shareTeams]});
}
